/**
 * Created by henian.xu on 2020/4/2.
 *
 */

import { get, post } from 'api/request';

// 创建线下发票
export function create({ orderId }) {
    return post(this.url, { orderId });
}

// 查询线下发票详情
export function detail({ orderId }) {
    return get(this.url, { orderId });
}

// 提交线下发票申请
export function confirm({ id }) {
    return post(this.url, { id });
}

// 取消
export function cancel({ id }) {
    return post(this.url, { id });
}
